import TemplateNames from './TemplateNames';

export default {
  title: 'E-mails automáticos',
  labels: {
    empty_list: 'Nenhum modelo encontrado',
    load_failed: 'Não foi possível carregar os seus e-mails automáticos. Recarregue a página ou contacte o suporte.',
    on: 'Ativo',
    off: 'Inativo',
  },
  fields: {
    name: 'Nome',
    messages_delivered: 'Mensagens Entregues',
    open_rate: 'Taxa de Abertura',
    click_rate: 'Taxa de Cliques',
    status: 'Estado',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_update_status: 'Erro ao atualizar estado',
    failed_to_load_data: 'Erro ao carregar dados',
  },
};
